import {
  SET_TRIALTAG,
  TrialTagActionTypes,
  TrialTag,
  AppThunk,
} from '../types';
import ApiClient from '../../loopback/apiClient';

export const setTrialTags = (payload: TrialTag[]): TrialTagActionTypes => ({
  type: SET_TRIALTAG,
  payload,
});

export const fetchTrialTags = (): AppThunk => async (dispatch): Promise<void> => {
  const trialTags = await ApiClient.getTrialTags();
  dispatch(setTrialTags(trialTags));
};
